/**
 * Helpers for assistant message text/streaming state.
 */

export function hasAssistantTextContent(message) {
  if (!message) return false;
  if (message.content?.length > 0) return true;
  return (message.parts || []).some((p) => p.kind === 'text' && p.content?.length > 0);
}

/**
 * Show streaming caret only when the last part is text (or there are no parts yet).
 * @param {Object} message
 * @returns {boolean}
 */
export function shouldShowStreamingCaret(message) {
  const parts = message?.parts;
  if (!parts?.length) return true;
  const last = parts[parts.length - 1];
  return last.kind === 'text';
}
